import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';

export function getToken() {
  let result = sessionStorage.getItem('token');
  if (result) {
    const { content } = JSON.parse(result);
    return content;
  }
  return '';
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
